import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { storageTitles } from '../shared/utils/consts';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  constructor() {}

  setRolesInSession(roles: string[]) {
    sessionStorage.setItem(
      `${environment.storagePrefix}_${storageTitles.ROLES}`,
      JSON.stringify(roles)
    );
  }

  getRolesFromSession(): string[] {
    const roles = sessionStorage.getItem(
      `${environment.storagePrefix}_${storageTitles.ROLES}`
    );

    if (roles) {
      return JSON.parse(roles);
    }

    return [];
  }

  getActiveRouteBeforeLogoutFromSession(): string {
    return (
      sessionStorage.getItem(`${environment.storagePrefix}_ActiveRoute`) ?? ''
    );
  }

  setActiveRouteBeforeLogoutFromSession(activeRoute: string): void {
    sessionStorage.setItem(
      `${environment.storagePrefix}_ActiveRoute`,
      activeRoute
    );
  }
}
